import React, { useState } from "react";
import { Link } from "gatsby";
import {
  languagesData,
  languagesPairsData,
  languagesDataMobile1,
  languagesDataMobile2,
  languagesPairsDataMobile1,
  languagesPairsDataMobile2,
} from "./config";

function MainLanguages() {
  const [openLanguages, setOpenLanguages] = useState(false);
  const [openLanguagesPairs, setOpenLanguagesPairs] = useState(false);
  const [languageAccordian, setLanguageAccordian] = useState(true);
  const [languagePairsAccordian, setLanguagePairsAccordian] = useState(true);

  const languageHandler = () => {
    setOpenLanguages((open) => !open);
    setLanguageAccordian((open) => !open);
  };
  const languagePairsHandler = () => {
    setOpenLanguagesPairs((open) => !open);
    setLanguagePairsAccordian((open) => !open);
  };

  const chevronUp = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-chevron-up"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
      />
    </svg>
  );

  const chevronDown = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-chevron-down"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );

  return (
    <section>
      <div className="bg-darkBlue py-28">
        <div className="w-11/12 md:w-8/12 lg:w-10/12 mx-auto max-w-6xl">
          <h2 className="font-secondary font-semibold text-45 text-white text-center mb-9 hidden sm:block">
            Over
            <span className="text-orange"> 120 languages</span>
          </h2>
          <h2 className="font-secondary font-semibold text-45 text-white text-center mb-9 block sm:hidden">
            Over
            <br />
            <span className="text-orange"> 120 languages</span>
          </h2>
          <ul className="hidden md:grid text-[#C2C2C2] text-[16px]   grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 main-languages gap-2">
            {languagesData.map(({ text, link }, index) => {
              return (
                <li key={index}>
                  <Link to={link} className="cursor-pointer">
                    {text}
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul className="grid md:hidden text-[#C2C2C2] text-[16px]   grid-cols-1 main-languages gap-2">
            <div className="grid grid-cols-2 gap-2">
              {languagesDataMobile1.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link to={link} className="cursor-pointer">
                      {text}
                    </Link>
                  </li>
                );
              })}
            </div>
            <div className="mt-7">
              {languageAccordian && (
                <div className="flex justify-between items-center bg-midBlue px-3 py-4 bottom-1 rounded-sm max-w-sm">
                  <p className="text-[22px] text-white">See More</p>
                  <p onClick={languageHandler} className="cursor-pointer">
                    {chevronDown}
                  </p>
                </div>
              )}
              {openLanguages && (
                <div className="grid grid-cols-2 gap-2">
                  {languagesDataMobile2.map(({ text, link }, index) => {
                    return (
                      <li key={index}>
                        <Link to={link} className="cursor-pointer">
                          {text}
                        </Link>
                      </li>
                    );
                  })}
                </div>
              )}
            </div>
          </ul>
        </div>
      </div>
      <div className="bg-midBlue py-28">
        <div className="w-11/12 md:w-10/12 mx-auto max-w-6xl text-[#E6E6E6]">
          <h2 className="font-secondary font-semibold text-45 text-white mb-9 hidden sm:block">
            950+
            <span className="text-orange"> Language Pairs</span>
          </h2>
          <h2 className="font-secondary font-semibold text-45 text-white mb-9 sm:hidden">
            950+
            <br />
            <span className="text-orange"> Language Pairs</span>
          </h2>
          <p className="text-[#E6E6E6] text-[16px] mb-12">
            With global language offerings of more than 950+ language pairs,
            Tomedes can extend your message across the globe to each of your
            audiences. It's now easier for you to convey your meaning through
            professional translation done by expert translators. Coupled with a
            wide range of industry expertise for your business, these are our
            popular language pairs:With global language offerings of more than
            950+ language pairs, Tomedes can extend your message across the
            globe to each of your audiences. It's now easier for you to convey
            your meaning through professional translation done by expert
            translators. Coupled with a wide range of industry expertise for
            your business, these are our popular language pairs:
          </p>
          <ul className="ml-7 md:ml-0 text-[#C2C2C2] text-[16px] hidden md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 main-languages gap-2">
            {languagesPairsData.map(({ text, link }, index) => {
              return (
                <li key={index}>
                  <Link to={link} className="cursor-pointer">
                    {text}
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul className="grid md:hidden text-[#C2C2C2] text-[16px]   grid-cols-1 main-languages">
            <div className="grid grid-cols-1 gap-2">
              {languagesPairsDataMobile1.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link to={link} className="cursor-pointer">
                      {text}
                    </Link>
                  </li>
                );
              })}
            </div>
            <div className="mt-7">
              {languagePairsAccordian && (
                <div className="flex justify-between items-center bg-[#00245A] px-3 py-4 bottom-1 rounded-sm max-w-sm">
                  <p className="text-[22px] text-white">See More</p>
                  <p onClick={languagePairsHandler} className="cursor-pointer">
                    {chevronDown}
                  </p>
                </div>
              )}
              {openLanguagesPairs && (
                <div className="grid grid-cols-1 gap-2">
                  {languagesPairsDataMobile2.map(({ text, link }, index) => {
                    return (
                      <li key={index}>
                        <Link to={link} className="cursor-pointer">
                          {text}
                        </Link>
                      </li>
                    );
                  })}
                </div>
              )}
            </div>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default MainLanguages;
